(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["senseso-fill-banner"] && !Shopify.designMode) return;
  try {
    (() => {
    const update = (banner) => {
      const grid = banner.parentElement;
      if (!grid) return;
      const tracks = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || 1;
      const cards = [...grid.children].filter(
        (el) => el !== banner && el.tagName !== 'SCRIPT' && el.tagName !== 'TEMPLATE' && getComputedStyle(el).display !== 'none'
      ).length;
      const remainder = cards % tracks;
      banner.style.setProperty('--senseso-fill-span-auto', String(tracks - remainder));
      banner.dataset.filled = remainder === 0 ? 'false' : 'true';
    };

    const observe = () => {
      document.querySelectorAll('[data-senseso-fill-auto]').forEach((banner) => {
        update(banner);
        if (banner.sensesoObserved || !banner.parentElement) return;
        banner.sensesoObserved = true;
        new ResizeObserver(() => update(banner)).observe(banner.parentElement);
      });
    };

    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        observe();
      });
    };

    observe();
    document.addEventListener('DOMContentLoaded', schedule);
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
